export const isNumberArray = (value: unknown): value is number[] => {
	if (!Array.isArray(value)) return false;
	return value.every((x) => typeof x === 'number');
};
